import { useState } from "react";
import "./VideoThumbnail.css";
import config from "../../config";

const VideoThumbnail = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="video-thumbnail">
      {!isPlaying ? (
        <div className="thumbnail-container">
          <img
            src={config.market01}
            alt="Video Thumbnail"
            className="thumbnail-image"
          />
          <button className="play-button" >
          {/* <button className="play-button" onClick={() => setIsPlaying(true)}> */}
            ▶
          </button>
          <div className="text-overlay">
            <p className="category">CONSULTING</p>
            <h2>
              Check out our new product where <br />
              we’ll show you all the upgrades
            </h2>
          </div>
        </div>
      ) : (
        <iframe
          className="video-frame"
          src="your-video-url.mp4"
          title="Video"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
};

export default VideoThumbnail;